import React from 'react';
import replaceCharacters from '../../components/utilities/helpers';
import { RequestIdTableCell } from '../../components/utilities/Table/RequestIdTableCell';
import { RedirectTableCell } from '../../components/utilities/Table/RedirectTableCell';
import { TooltipTableCell } from '../../components/utilities/Table/TooltipTableCell';
import { RequestDays } from '../../components/utilities/Table/generalColumns/RequestIdWithWarning';

const requestsListStatus = [
    {
        id: 'bolsa_general_desembolso',
        label: 'BOLSA GENERAL',
        status: 60,
        responsable: false,
        columns: [
            {
                Header: () => 'Solicitud',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={
                                'gestionsolicitud.fecha_legalizacion'
                            }
                        />
                    );
                },
            },
            RequestDays('gestionsolicitud.fecha_creacion'),
            {
                Header: 'Fecha Legalización',
                accessor: 'gestionsolicitud.fecha_legalizacion',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                typeId: 'HeaderIdentification',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
                typeId: 'HeaderClient',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: () => 'Pagaré electrónico',
                id: 'codigo_deceval',
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.original?.firma_electronica_deceval
                                ? 'SI'
                                : 'NO'}
                        </div>
                    );
                },
            },
        ],
        buttonAction: [{ name: 'takeRequest' }],
    },
    {
        id: 'en_proceso_desembolso',
        label: 'EN PROCESO',
        status: 60,
        responsable: true,
        columns: [
            {
                Header: () => 'Solicitud',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return (
                        <RequestIdTableCell
                            row={row}
                            comparativeDateField={
                                'gestionsolicitud.fecha_legalizacion'
                            }
                        />
                    );
                },
            },
            RequestDays('gestionsolicitud.fecha_creacion'),
            {
                Header: 'Fecha Legalización',
                accessor: 'gestionsolicitud.fecha_legalizacion',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                typeId: 'HeaderIdentification',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                Footer: 'Cliente',
                typeId: 'HeaderClient',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: () => 'Pagaré electrónico',
                id: 'codigo_deceval',
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.original?.firma_electronica_deceval
                                ? 'SI'
                                : 'NO'}
                        </div>
                    );
                },
            },
        ],
    },
    {
        id: 'procesadas_desembolso',
        label: 'PROCESADAS',
        status: 90,
        responsable: null,
        //nameColumnProcessed: [],
        columns: [
            {
                Header: () => 'Solicitud',
                id: 'id',
                typeId: 'HeaderRequest',
                Cell: ({ row }) => {
                    return <RequestIdTableCell row={row} />;
                },
            },
            {
                Header: 'Número Crédito',
                accessor: 'codigo_gyg',
            },
            {
                Header: 'Fecha Desembolso',
                accessor: 'gestionsolicitud.fecha_desembolso',
            },
            {
                Header: () => 'Identificación',
                id: 'numero_identificacion',
                typeId: 'HeaderIdentification',
                Cell: ({ row }) => (
                    <RedirectTableCell
                        route={`/app/clients/consult/${row.original.persona.numero_identificacion}/${row.original.persona.tipo_identificacion.value}`}
                        label={row.original.persona.numero_identificacion}
                    />
                ),
            },
            {
                Header: 'Cliente',
                accessor: 'persona.full_name',
                typeId: 'HeaderClient',
            },
            {
                Header: () => 'Ejecutivo',
                id: 'ejecutivo',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.name
                        }
                        tooltipText={
                            row.original?.gestionsolicitud?.usuario_ejecutivo
                                ?.email
                        }
                    />
                ),
            },
            {
                Header: 'Producto',
                accessor: 'subproducto.label',
            },
            {
                Header: () => 'Pagaré electrónico',
                id: 'codigo_deceval',
                Cell: ({ row }) => {
                    return (
                        <div>
                            {row.original?.firma_electronica_deceval
                                ? 'SI'
                                : 'NO'}
                        </div>
                    );
                },
            },
            {
                Header: () => 'Estado',
                id: 'estado_solicitud',
                Cell: ({ row }) => (
                    <TooltipTableCell
                        label={row.original.estado_solicitud.label}
                        tooltipText={replaceCharacters(
                            'data-estate-request',
                            row.original
                        )}
                    />
                ),
            },
            {
                Header: 'Envío a gyg',
                accessor: 'estado_envio_gyg.label',
            },
        ],
        registrationLimit: 5, // limit for registration in list credits
        buttonAction: [{ name: 'resumeStatusRequest' }],
    },
];

export default requestsListStatus;
